'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/lib/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _SocialMediaWindow = require('./lib/SocialMediaWindow');

var _ShareButton = require('./ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookIcon = _react2.default.createElement(
  'span',
  { className: 'ec-share-icon__svg ec-share-icon__svg--facebook' },
  _react2.default.createElement(
    'svg',
    { focusable: 'false', viewBox: '0 0 32 32' },
    _react2.default.createElement('path', { d: 'M12.1 32V17H8v-5.4h4.1V7c0-3.6 2.4-7 8-7 2.2 0 3.9.2 3.9.2l-.1 5.1h-3.6c-2 0-2.3.9-2.3 2.4v3.9h6l-.3 5.4H18v15h-5.9z' })
  )
);

var Facebook = function Facebook(_ref) {
  var caption = _ref.caption,
      description = _ref.description,
      link = _ref.link,
      name = _ref.name,
      picture = _ref.picture,
      onClickCallback = _ref.onClickCallback;
  return _react2.default.createElement(_ShareButton2.default, {
    icon: FacebookIcon,
    name: 'Facebook',
    onClick: function onClick() {
      if (onClickCallback) onClickCallback();

      var url = 'https://www.facebook.com/dialog/feed?app_id=58567469885&redirect_uri=http%3A%2F%2Fwww.bbc.co.uk%2Fmodules%2Fshare%2Fclose&display=popup';

      if (description) url += '&description=' + encodeURIComponent(description);
      if (caption) url += '&caption=' + encodeURIComponent(caption);
      if (picture) url += '&picture=' + encodeURIComponent(picture);
      if (name) url += '&name=' + encodeURIComponent(name);

      url += '&link=' + encodeURIComponent(link);
      (0, _SocialMediaWindow.openWindow)(url);
    }
  });
};

Facebook.propTypes = {
  link: _PropTypes2.default.string.isRequired,
  description: _PropTypes2.default.string,
  picture: _PropTypes2.default.string,
  name: _PropTypes2.default.string,
  caption: _PropTypes2.default.string,
  onClickCallback: _PropTypes2.default.func
};

exports.default = Facebook;